import csvInfoText from './edith_infoTexte.csv'
import csvToJson from '../csvToJson'
function parseInfoTextCsv() {
    let preContent = csvToJson(csvInfoText);
    let result = {}
    for(const item of preContent) {
        result[item['KEY']] = item['VALUE']
    }
    return result
}

const infoTexte = parseInfoTextCsv()
export default infoTexte